export const commonFunction = {
    getSiteAcronym,
    replaceNonAdmitedSymbols
};

function getSiteAcronym(idSite) {
    switch (idSite) {
        case 1: return 'EE';
        case 2: return 'AG';
        case 3: return 'EN';
        case 4: return 'MD';
        case 100: return 'XP';
        default: return "";
    }
}

function replaceNonAdmitedSymbols(selectText) {
    selectText = selectText.replace("/([\t]+(?=[\t])|^s+|s+$)/g", '').trimStart().trimEnd();
    selectText = selectText.replace("'", "`");
    selectText = selectText.replace(String.fromCharCode(34), "`");
    selectText = selectText.replace(String.fromCharCode(39), "`");
    var re = new RegExp(String.fromCharCode(160), "g");
    selectText = selectText.replace(re, " ");
    return selectText;
}